module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_8017.df980ef4.png";